var map = {
	"./arrow-beige.png": 24,
	"./arrow.png": 25,
	"./background.jpg": 26,
	"./flags/be.svg": 27,
	"./flags/cn.svg": 28,
	"./flags/de.svg": 29,
	"./flags/es.svg": 30,
	"./flags/fr.svg": 31,
	"./flags/gb.svg": 32,
	"./flags/it.svg": 33,
	"./flags/jp.svg": 34,
	"./flags/us.svg": 35,
	"./icons/arrow-light.svg": 36,
	"./icons/arrow.svg": 37,
	"./icons/back.svg": 38,
	"./icons/clock.svg": 39,
	"./icons/close.svg": 40,
	"./icons/error.svg": 41,
	"./icons/facebook.svg": 42,
	"./icons/info.svg": 43,
	"./icons/instagram.svg": 44,
	"./icons/linkedin.svg": 45,
	"./icons/logo-secondary.svg": 46,
	"./icons/mail.svg": 47,
	"./icons/marker.svg": 48,
	"./icons/phone.svg": 49,
	"./icons/picto.svg": 50,
	"./icons/pin.svg": 51,
	"./icons/pinterest.svg": 52,
	"./icons/slider-arrow.svg": 53,
	"./icons/success.svg": 54,
	"./icons/twitter.svg": 55,
	"./icons/weibo.svg": 56,
	"./icons/youtube.svg": 57,
	"./logo-small.png": 58,
	"./logo-small.svg": 59,
	"./logo.png": 60,
	"./logo.svg": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;